import React from 'react';
import { Container, Typography, Paper, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <Container maxWidth="md">
      <Box mt={8} display="flex" justifyContent="center">
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h1" component="h1" gutterBottom>
            404
          </Typography>
          <Typography variant="h4" component="h2" gutterBottom>
            Page Not Found
          </Typography>
          <Typography variant="body1" gutterBottom>
            The page you're looking for doesn't exist.
          </Typography>
          <Button 
            component={Link} 
            to="/" 
            variant="contained" 
            sx={{ mt: 2 }}
          >
            Go Home
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFoundPage; 